import {faClipboardList} from '@fortawesome/pro-solid-svg-icons';

export const ASSET_PROJECT_ACTION_ICON = <const>{
	PROJECT: faClipboardList,
	ADD_TO_PROJECT: faClipboardList,
	CREATE_PROJECT: faClipboardList,
};

export type AssetProjectBaseVent = typeof ASSET_PROJECT_BASE_EVENT;

export const ASSET_PROJECT_BASE_EVENT = `asset:project`;

export const ASSET_PROJECT_EVENT = <const>{
	PROJECT: `${ASSET_PROJECT_BASE_EVENT}`,
	ADD_TO_PROJECT: `${ASSET_PROJECT_BASE_EVENT}:add`,
	CREATE_PROJECT: `${ASSET_PROJECT_BASE_EVENT}:new`,
};
